import React from "react";

import { StyledSVG } from "../StyledIcon";

export const MessagingIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M2 15H1.25C1.25 15.2678 1.39283 15.5153 1.62473 15.6494C1.85662 15.7834 2.14239 15.7836 2.37445 15.6498L2 15ZM4.71012 13.4383L4.33566 12.7885L4.71012 13.4383ZM3 3.75H15V2.25H3V3.75ZM15.25 4V12.2857H16.75V4H15.25ZM2.75 15V4H1.25V15H2.75ZM15 12.5357H5.28071V14.0357H15V12.5357ZM4.33566 12.7885L1.62555 14.3502L2.37445 15.6498L5.08457 14.0882L4.33566 12.7885ZM5.28071 12.5357C4.94899 12.5357 4.62309 12.6229 4.33566 12.7885L5.08457 14.0882C5.14422 14.0538 5.21186 14.0357 5.28071 14.0357V12.5357ZM15.25 12.2857C15.25 12.4238 15.1381 12.5357 15 12.5357V14.0357C15.9665 14.0357 16.75 13.2522 16.75 12.2857H15.25ZM15 3.75C15.1381 3.75 15.25 3.86193 15.25 4H16.75C16.75 3.0335 15.9665 2.25 15 2.25V3.75ZM3 2.25C2.0335 2.25 1.25 3.0335 1.25 4H2.75C2.75 3.86193 2.86193 3.75 3 3.75V2.25Z"
        fill={iconColor}
      />
    </StyledSVG>
  );
};
